import React from 'react';
import { Input, Form } from 'antd';

const FormInputComponent = ({ name, rules, autoComplete, onKeyPress, allowClear, className, placeholder, disabled, addonAfter, onKeyDown, onChange, onFocus, onBlur, help }) => {
    return (
        <Form.Item name={name} rules={rules} className={className} help={help} >
            <Input
                onKeyPress={onKeyPress}
                autoComplete={autoComplete}
                allowClear={allowClear}
                placeholder={placeholder}
                disabled={disabled}
                onKeyDown={onKeyDown}
                onChange={onChange}
                addonAfter={addonAfter}
                onFocus={onFocus}
                onBlur={onBlur}
            />
        </Form.Item>
    );
};

export default FormInputComponent;
